import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { createFragmentContainer, graphql } from 'react-relay';
import queryString from 'query-string';
import { isEmpty } from 'ramda';

import { Label, StoreProvider } from '../../components';
import FormHeader from '../../components/FormHeader';
import Group from '../../components/Group';
import Row from '../../components/Row';
import Column from '../../components/Column';

import UsersTable from './components/UsersTable';

const UsersView = (props) => {
  const { lists, userEmail } = props;
  const [email, setEmail] = useState(userEmail);
  const users = lists.usersByEmail.edges.map((e) => e.node);
  const history = useHistory();

  const handleEmailUpdate = ({ target: { value } }) => setEmail(value);

  const handleSubmit = (event) => {
    event.preventDefault();
    const url = `/fastcash/users?email=${email.replace(/\+/g, '_')}`;

    history.push(url);
  };

  const shouldShowTable = userEmail && !isEmpty(users);
  const isUsersBlank = userEmail && isEmpty(users);

  return (
    <div>
      <div className="users">
        <form className="user-find-form" onSubmit={handleSubmit}>
          <FormHeader title="Users">
            <input
              id="userFind"
              className="user-find-submit"
              type="submit"
              defaultValue="Find"
            />
          </FormHeader>
          <Group>
            <Row>
              <Column>
                <Label attr="email" text="Email" />
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={handleEmailUpdate}
                />
              </Column>
            </Row>
          </Group>
        </form>
      </div>
      {isUsersBlank && <div>No users found</div>}
      {shouldShowTable && <UsersTable users={users} />}
    </div>
  );
};

const UsersContainer = createFragmentContainer(UsersView, {
  lists: graphql`
    fragment Users_lists on Lists
    @argumentDefinitions(email: { type: "String!" }) {
      id
      usersByEmail(first: 1000, email: $email)
        @connection(key: "Users_usersByEmail") {
        edges {
          node {
            id
            ...UserCell_user
          }
        }
      }
    }
  `,
});

const Users = (props) => {
  const queryParams = queryString.parse(props.location.search);
  const { email } = queryParams;

  const preprocessParams = () => {
    const variables = { email: email || '' };

    return variables;
  };

  return (
    <StoreProvider
      container={UsersContainer}
      modern
      preprocessParams={preprocessParams}
      userEmail={email}
      query={graphql`
        query UsersQuery($email: String!) {
          lists {
            ...Users_lists @arguments(email: $email)
          }
        }
      `}
    />
  );
};

export default Users;
